module.exports = __webpack_public_path__ + "img/view.6b77ebed.jpg";